import { Spinner } from '../Spinner';
import { tv } from 'tailwind-variants';

type LoaderScreenProps = {
  /**
   * 親要素のサイズに合わせて表示するかどうか
   * @default false - 全画面表示（h-screen w-screen）
   * @param true - 親要素のサイズに合わせる（size-full）
   */
  contained?: boolean;
  className?: string;
};

const Wrapper = tv({
  base: 'flex items-center justify-center',
  variants: {
    contained: {
      true: 'size-full',
      false: 'h-screen w-screen',
    },
  },
});

export const LoaderScreen = ({
  contained = false,
  className,
}: LoaderScreenProps) => (
  <div className={Wrapper({ contained, className })}>
    <Spinner size="xl" className="text-primary-teal" />
  </div>
);
